import { runWithAdal } from 'react-adal';
import { authContext } from './components/Azure/adalConfig';
 
import 'react-app-polyfill/ie11';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
//import * as serviceWorker from './serviceWorker';
//import { HashRouter } from 'react-router-dom'
import {BrowserRouter as Router} from "react-router-dom";
import ScrollToTop from './ScrollToTop';
//import {Loadding} from '../../components/Loadding';
// import i18n (needs to be bundled ;)) 
import './components/Translation/i18n';
import { Provider } from 'react-redux';
import store from "./store/reducers/rootReducer";
import Loadding from './components/Loadding';

const DO_NOT_LOGIN = false;


authContext.handleWindowCallback();
try{
    runWithAdal(authContext, () => {    
      // eslint-disable-next-line
      ReactDOM.render(
        <Provider store={store}>
            <Router>
                <Suspense fallback={(<Loadding/>)}>
                        <ScrollToTop>
                            <App/>
                        </ScrollToTop>
                </Suspense>
            </Router>
        </Provider>,
        document.getElementById('root')
    );   
    },DO_NOT_LOGIN);
}catch(e){
    console.log(e);
}



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();